module.exports = __webpack_public_path__ + "img/Autocolant TCLE-01.c4898c74.jpg";